import * as React from "react";
import { FunctionComponent, useEffect, useState } from "react";
import "./CountryAndPhone.css";
import { CountrySelector, usePhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { ITextFieldStyles, TextField } from "@fluentui/react";

interface Props {
  onValueChanged?: (countryCode: string, phoneNumber: string) => void;
}

const CountryAndPhone: FunctionComponent<Props> = (props: Props) => {
  const { onValueChanged } = props;
  const [phoneNumber, setPhoneNumber] = useState("");
  const validatePhone = new RegExp(/^(^$)|[\d-]+$/);

  const { inputValue, phone, country, setCountry, handlePhoneValueChange, inputRef } = usePhoneInput({
    defaultCountry: "gb",
    onChange: ({ phone, inputValue, country }) => {
      if (onValueChanged) onValueChanged(phone, phoneNumber);
    },
  });

  const textFieldStyles: Partial<ITextFieldStyles> = {
    fieldGroup: {
      backgroundColor: "#f2f3f6",
      height: "2.5rem",
      border: "0",
      borderRadius: "0 4px 0 0",
      borderBottom: "1px solid #48454E",
      fontSize: "0.875rem",
      fontWeight: 800,
      letterSpacing: "0.0125rem",
      ":after": {
        border: 0,
        outline: "none",
      },
    },
  };

  const dropDownButtonStyle: React.CSSProperties = {
    height: "2.5rem",
    borderRadius: "4px 0 0 0",
    borderBottom: "1px solid #48454E",
  };

  const phoneNumberOnChange = (newValue: string) => {
    if (validatePhone.test(newValue)) {
      setPhoneNumber(newValue);
      if (onValueChanged) onValueChanged(phone, newValue);
    }
  };

  useEffect(() => {}, []);

  return (
    <>
      <div>
        <CountrySelector
          buttonStyle={dropDownButtonStyle}
          className="country-selector-container"
          selectedCountry={country.iso2}
          onSelect={(va) => {
            setCountry(va.iso2);
          }}
        />
        <div className="country-code-text">
          <TextField
            value={inputValue}
            placeholder="Country code"
            style={{ width: "5rem" }}
            styles={textFieldStyles}
            onChange={(ev, newValue) => {
              const a = newValue;
            }}
          />
        </div>
        <div className="country-phone-text">
          <TextField
            placeholder="Phone number"
            value={phoneNumber}
            styles={textFieldStyles}
            onChange={(ev, newValue) => {
              phoneNumberOnChange(newValue);
            }}
          />
        </div>
      </div>
    </>
  );
};

export default CountryAndPhone;
